<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="certificate"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="证书名称："
        prop="certName">
        <el-input
          v-model.number="certificate.certName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="机构名称："
        prop="regulatorName">
        <el-input
          v-model.number="certificate.regulatorName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="所属企业："
        prop="vendorId">
        <ent-remote-select
          v-if="!certificate.certId && certificate.certLevel === 2"
          ref="entRemoteSelect"
          v-model="certificate.vendorId" />
        <span v-else>{{ certificate.vendorName }}</span>
      </el-form-item>
      <template v-if="!certificate.certId">
        <el-form-item
          label="有效期："
          prop="time">
          <el-date-picker
            v-model="certificate.time"
            style="width: 100%;"
            type="daterange"
            unlink-panels
            :editable="false"
            range-separator=""
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="证书文件："
          prop="certFile">
          <upload-with-crop
            v-model="certificate.certFile"
            :limit="5"
            :isLt2M="500"
            :fixedNumber="[1,1]"
            :autoCropWidth="80"
            :autoCropHeight="80" />
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import Commom from '@/service/common'
import EntRemoteSelect from '@/components/ent-remote-select.vue'
export default {
  name: 'CertificateModal',
  components: { UploadWithCrop, EntRemoteSelect },
  data() {
    return {
      loading: false,
      visible: false,
      certificate: { vendorId: null, vendorName: '', certId: null, certName: '', regulatorName: '', time: undefined, certFile: [], certLevel: 1 },
      rules: {
        certName: [{ required: true, message: '请输入证书名称', trigger: 'blur' }],
        regulatorName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        vendorId: [{ required: true, message: '请选择所属企业', trigger: 'blur' }],
        time: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        certFile: [{ required: true, message: '请上传证书文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    title({ certificate }) {
      return !certificate.certId ? '新建证书' : '修改证书'
    }
  },
  methods: {
    init(row = {}) {
      this.certificate = { ...this.certificate, ...row }
      this.visible = true
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.certificate = { ...this.certificate, ...this.$options.data().certificate }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { certId } = this.certificate
          this.loading = true
          Commom[certId ? 'updatecertificate' : 'addcertificate']({ ...this.certificate, ...this.getQuery(this.certificate) })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    getQuery() {
      if (this.certificate.certId) {
        return { time: undefined, certFile: undefined }
      }
      const { time, certFile } = this.certificate
      return { certBeginTime: +time[0], certEndTime: +time[1], certFile: certFile.map(item => item.url).join(','), time: undefined }
    }
  }
}
</script>
